import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { BeehiivEmbed } from './BeehiivEmbed';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/stqm5AGzNCcfijGhb8aoNs/Hero.png';
const BEEHIIV_FORM_ID = '283609c2-3ea4-4f4f-b529-4657d18b33ef';
export function Hero() {
  return <section id="top" aria-labelledby="hero-heading" className="relative w-full" data-id="element-6" data-mp="4n1j0kwg00pc">
      <div className="relative h-[56vh] min-h-[360px] w-full overflow-hidden sm:h-[68vh] lg:h-[86vh] lg:min-h-[640px]" data-id="element-7" data-mp="128fqzmni4jxa">
        <motion.img src={HERO_IMAGE} alt="Illustration of neighbors enjoying Hayward Park: a family picnic with pizza, kids climbing an orange rope pyramid, and the city skyline beyond the trees." className="h-full w-full object-cover object-[center_55%]" initial={{
        scale: 1.04,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-8" data-mp="xaxgvsxqzynp" />
      </div>

      <div className="w-full bg-white" data-id="element-9" data-mp="3j89618jhw3nf">
        <motion.div id="subscribe" initial={{
        y: 24,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.25,
        ease: [0.22, 1, 0.36, 1]
      }} className="scroll-mt-20 mx-auto grid max-w-7xl gap-8 px-4 py-14 sm:px-6 sm:py-16 lg:grid-cols-[1.1fr_1fr] lg:items-center lg:gap-14 lg:px-8 lg:py-20" data-id="element-10" data-mp="3j9ah3d0igq55">
          <div data-id="element-11" data-mp="30h9d5w8vq9ov">
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-wt-footer-background-color" data-id="element-12" data-mp="30gq47517ivmz">
              Friends of Margaret S. Hayward Park
            </p>
            <SectionHeading as="h1" size="xl" id="hero-heading" className="text-wt-primary-color" data-id="element-13" data-mp="2ql69un2ak50c">
              Welcome, Friends
            </SectionHeading>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-neutral-700 sm:text-lg" data-id="element-14" data-mp="2hjf6vpz4yca6">
              If you love and use Hayward Park, you'll want to subscribe and get
              alerts for upcoming events and opportunities to serve our community
              at the park.
            </p>
          </div>
          <div className="w-full min-w-0" data-id="element-15" data-mp="nb1kz5gpvtwy">
            <BeehiivEmbed formId={BEEHIIV_FORM_ID} className="w-full font-['Montserrat',ui-sans-serif,system-ui,sans-serif] [&_form]:!w-full [&_form]:!max-w-none [&_iframe]:!w-full [&_iframe]:!max-w-none [&_input]:font-['Montserrat'] [&_button]:font-['Montserrat']" data-id="element-16" data-mp="na0ab23m59fr" />
            <p className="mt-3 text-sm text-neutral-500" data-id="element-17" data-mp="1ayt7f1vz1nby">
              A friendly email now and then. Unsubscribe anytime.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}